import { useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Typography,
  IconButton,
  Tooltip,
  Fab,
} from "@mui/material";
import FeedbackIcon from "@mui/icons-material/Feedback";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import CloseIcon from "@mui/icons-material/Close";

const WA_NUMERO = "59177858921"; // tu número de soporte

export default function FeedbackWA({ appName = "la app" }) {
  const [open, setOpen] = useState(false);
  const [mensaje, setMensaje] = useState("");

  const enviar = () => {
    if (!mensaje.trim()) return;
    const texto = `[Feedback - ${appName}]\n\n${mensaje.trim()}`;
    window.open(
      `https://wa.me/${WA_NUMERO}?text=${encodeURIComponent(texto)}`,
      "_blank"
    );
    setMensaje("");
    setOpen(false);
  };

  return (
    <>
      <Tooltip title="Enviar feedback">
        <Fab
          size="small"
          color="success"
          onClick={() => setOpen(true)}
          sx={{
            position: "fixed",
            bottom: 24,
            right: 24,
            zIndex: 1200,
          }}
        >
          <FeedbackIcon />
        </Fab>
      </Tooltip>

      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <Typography fontWeight={700}>Enviar Feedback</Typography>
          <IconButton size="small" onClick={() => setOpen(false)}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            ¿Tienes una sugerencia, encontraste un error o quieres pedir una función?
            Escríbenos directo por WhatsApp.
          </Typography>
          <TextField
            autoFocus
            multiline
            rows={4}
            fullWidth
            placeholder="Escribe tu mensaje aquí..."
            value={mensaje}
            onChange={(e) => setMensaje(e.target.value)}
          />
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={() => setOpen(false)}>Cancelar</Button>
          <Button
            variant="contained"
            startIcon={<WhatsAppIcon />}
            onClick={enviar}
            disabled={!mensaje.trim()}
            sx={{ bgcolor: "#25d366", "&:hover": { bgcolor: "#1da851" } }}
          >
            Enviar por WhatsApp
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
